// DEV - Health Policy

      // export const rootUrl = "https://conference.aanpdev.com:3000";
      // export const authApiUrl = "https://auth.aanpdev.com/api";
      // export const loginUrl = "https://profile.aanpdev.com/Account/LogOn";
      // export const apiUrl = "https://conference-api.aanpdev.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/events/2023-hpc";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpdev.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://profile.aanpdev.com/Account/Logout";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2023-hpc";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/";
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

// DEV - National In-Person

      // export const rootUrl = "https://salesforceauth.aanpqa.com";
      // export const loginUrl = "https://services-authproxy-sf.aanpqa.com/Account/Login";
      // export const apiUrl = "https://salesforceauth-api.aanpqa.com/api";      
      // export const relatedEventUrl = "https://www.aanp.org/national23-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // // this may go to logout-sf.aanpqa.com. requires testing
      // // https://services-authproxy-sf.aanpqa.com/account/logout
      // export const logoutUrl = "https://services-authproxy-sf.aanpqa.com/Account/Logout";
      // export const sentryDsn =   "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2023-national";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/";
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

// DEV - National On-Demand

      // export const rootUrl = "https://conference.aanpdev.com:3000";
      // export const authApiUrl = "https://auth.aanpdev.com/api";
      // export const loginUrl = "https://profile.aanpdev.com/Account/LogOn";
      // export const apiUrl = "https://national-ondemand-api.aanpdev.com/api";
      // export const relatedEventUrl = "https://www.aanpqa.com/national23-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpdev.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://profile.aanpdev.com/Account/Logout";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = false;

// DEV - Fall In-Person

      // export const rootUrl = "https://conferencereg.aanpdev.com:3000";
      // export const authApiUrl = "https://auth.aanpdev.com/api";
      // export const loginUrl = "https://profile.aanpdev.com/Account/LogOn";
      // export const apiUrl = "https://conferenceregapi.aanpdev.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall24-ondemand-notice";

      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpdev.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://profile.aanpdev.com/Account/Logout";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-fall";

      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = true;

// DEV - Fall On-Demand
      // export const rootUrl = "https://conference.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://fall-ondemand-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall23-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2023-aanp-fall-conference";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = false;


// QA - Health Policy

      // export const rootUrl = "https://hpconf.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://services-authproxy.aanpqa.com/Account/Login";
      // export const apiUrl = "https://hpconf-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/events/2026-hpc";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://services-authproxy.aanpqa.com/Account/Logout";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2026-hpc";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const orderHistoryUrl = "https://conferencereceipts-sf.aanpqa.com"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = true;

// QA - National In-Person

      // export const rootUrl = "https://national.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://national-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/national23-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2026-national";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/";
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl = "https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

// QA - National In-Person

      // export const rootUrl = "https://national.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://national-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/national23-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2023-national";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/";
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl = "https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

// QA - National On-Demand

      // export const rootUrl = "https://national-ondemand.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://national-ondemand-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/national23-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = false;

// QA - Fall In-Person

      // export const rootUrl = "https://fall.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://fall-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // // export const googleAnalyticsTrackingId = "";
      // // export const facebookPixelTrackingId = "";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";      
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-aanp-fall-conference";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = true;

// QA - Fall On-Demand

      // export const rootUrl = "https://fall-ondemand.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://fall-ondemand-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall24-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-aanp-fall-conference-online";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = false;

// Production - Health Policy

      export const rootUrl = "https://hpconf-v2.aanp.org";
      export const authApiUrl = "https://auth.aanp.org/api";
      export const loginUrl = "https://services-authproxy.aanp.org/Account/Login";
      export const apiUrl = "https://hpconf-api.aanp.org/api";
      export const relatedEventUrl = "https://www.aanp.org/events/2027-hpc";
      export const waitlistUrl = "https://waitlist.aanp.org/home/index/";
      export const cookieDomain = ".aanp.org";
      export const idleTimeoutMinutes = 60;
      export const logoutUrl = "https://services-authproxy.aanp.org/Account/Logout";
      export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      export const sentryEnvironment = "production";
      export const handleErrors = true;
      export const googleTagManagerId = "GTM-PJS6XZZ";
      export const googleAnalyticsTrackingId = "";
      export const facebookPixelTrackingId = "";
      export const conferenceGuideUrl = "https://www.aanp.org/events/2023-hpc";
      export const eBizNavUrl = "https://my.aanp.org/login.aspx?appUrl=https://my.aanp.org/"
      export const orderHistoryUrl = "https://conferencereceipts.aanp.org"
      export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      export const showEmergencyContactSection = true;

// Production - National In-Person

      // export const rootUrl = "https://national.aanp.org";
      // export const authApiUrl = "https://auth.aanp.org/api";
      // export const loginUrl = "https://my.aanp.org/login.aspx";
      // export const apiUrl = "https://national-api.aanp.org/api";
      // export const relatedEventUrl = "https://www.aanp.org/national24-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanp.org/home/index/";
      // export const cookieDomain = ".aanp.org";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanp.org/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "production";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-aanp-national-conference";
      // export const eBizNavUrl = "https://my.aanp.org/login.aspx?appUrl=https://my.aanp.org/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = true;

// Production - National On-Demand

      // export const rootUrl = "https://national-ondemand.aanp.org";
      // export const authApiUrl = "https://auth.aanp.org/api";
      // export const loginUrl = "https://my.aanp.org/login.aspx";
      // export const apiUrl = "https://national-ondemand-api.aanp.org/api";
      // export const relatedEventUrl = "https://www.aanp.org/national23-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanp.org/home/index/";
      // export const cookieDomain = ".aanp.org";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanp.org/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "Production";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "";
      // export const eBizNavUrl = "https://my.aanp.org/login.aspx?appUrl=https://my.aanp.org/";
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = false;

// Production - Fall In-Person

      // export const rootUrl = "https://fall.aanp.org";
      // export const authApiUrl = "https://auth.aanp.org/api";
      // export const loginUrl = "https://my.aanp.org/login.aspx";
      // export const apiUrl = "https://fall-api.aanp.org/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall-ondemand-notice";
      // export const waitlistUrl = "https://waitlist.aanp.org/home/index/";
      // export const cookieDomain = ".aanp.org";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanp.org/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "production";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-aanp-fall-conference";
      // export const eBizNavUrl = "https://my.aanp.org/login.aspx?appUrl=https://my.aanp.org/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = true;

// Production - Fall On-Demand

      // export const rootUrl = "https://fall-ondemand.aanp.org";
      // export const authApiUrl = "https://auth.aanp.org/api";
      // export const loginUrl = "https://my.aanp.org/login.aspx";
      // export const apiUrl = "https://fall-ondemand-api.aanp.org/api";
      // export const relatedEventUrl = "https://www.aanp.org/fall-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanp.org/home/index/";
      // export const cookieDomain = ".aanp.org";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanp.org/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "production";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "";
      // export const facebookPixelTrackingId = "";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2024-aanp-fall-conference";
      // export const eBizNavUrl = "https://my.aanp.org/login.aspx?appUrl=https://my.aanp.org/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall"
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national"
      // export const showEmergencyContactSection = false;

// QA - Conference Compass Mobile App Testing Site

      // export const rootUrl = "https://compassreg.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://compassreg-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanpqa.com/fall21-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "UA-21488605-1";
      // export const facebookPixelTrackingId = "184006142083085";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2021-fall";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

// QA - AANPconnect

      // export const rootUrl = "https://aanpconnect.aanpqa.com";
      // export const authApiUrl = "https://auth.aanpqa.com/api";
      // export const loginUrl = "https://my.aanpqa.com/login.aspx";
      // export const apiUrl = "https://aanpconnect-api.aanpqa.com/api";
      // export const relatedEventUrl = "https://www.aanpqa.com/fall21-inperson-notice";
      // export const waitlistUrl = "https://waitlist.aanpqa.com/home/index/";
      // export const cookieDomain = ".aanpqa.com";
      // export const idleTimeoutMinutes = 60;
      // export const logoutUrl = "https://my.aanpqa.com/logout.aspx";
      // export const sentryDsn = "https://90b66e2eaf24497daced071831b5c3be@sentry.io/1373060";
      // export const sentryEnvironment = "testing";
      // export const handleErrors = true;
      // export const googleTagManagerId = "GTM-PJS6XZZ";
      // export const googleAnalyticsTrackingId = "UA-21488605-1";
      // export const facebookPixelTrackingId = "184006142083085";
      // export const conferenceGuideUrl = "https://www.aanp.org/events/2021-fall";
      // export const eBizNavUrl = "https://my.aanpqa.com/login.aspx?appUrl=https://my.aanpqa.com/"
      // export const fallConferenceSessionsUrl = "https://sessions.aanp.org/fall";
      // export const nationalConferenceSessionsUrl="https://sessions.aanp.org/national";
      // export const showEmergencyContactSection = true;

export const storageKeys = {
      authToken: "AuthToken",
      registrationMembershipType: "RegistrationMembershipType",
      promoCode: "PromoCode",
      authCookieName: ".AANPAuth",
      joinRenewMembershipType: "JoinRenewMembershipType",
      registrationMethod: "RegistrationMethod",
      impersonatingContactId: "ImpersonatingContactId",
      isNp: "IsNp",
};